// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Card, CardContent, CardHeader, Divider, Typography} from '@mui/material';
import {t} from 'ttag';

const AtcMask = ({mask}) => {
  return (
    <Card elevation={3}>
      <CardHeader title={<Typography fontFamily={'OpenSansMedium'}>{t`Mask`}</Typography>}/>
      <Divider/>
      <CardContent>
        <Box sx={{backgroundColor: 'black', color: 'white', borderRadius: '5px', padding: '5px 15px', fontSize: '100%'}}>
          <pre>
            {mask}
          </pre>
        </Box>
      </CardContent>
    </Card>
  );
};

AtcMask.propTypes = {
  mask: PropTypes.string,
};

export default AtcMask;
